function getOffsetHeight(max, headline) {
console.log( headline.offsetHeight );

    if ( max == 'maxHeightThreeLines' && headline.offsetHeight < 155 ) {
        // dreizeilig
        // console.log( 'dreizeilig: ', headline.offsetHeight, 'text: ', headline.innerHTML );
        

        return true;

    } else if ( max == 'maxHeightTwoLines' && headline.offsetHeight < 120 ) {
        // zweizeilig
        // headline.classList.add(zeilenhoehe);
        // headline.innerHTML = headline.innerHTML + '<span></span>';
        return true;

    } else if ( max == 'maxHeight' && headline.offsetHeight < 60 ) {
        // einzeilig
        return true;
    } else {
        return false;
    }
}

function getLineOne(headline) {
    if ( getOffsetHeight('maxHeight', headline) ) {
        return true;
    } else {
        return false;
    }
}

function getLineTwo(headline) {
    if ( getOffsetHeight('maxHeightTwoLines', headline) ) {
        return true;
    } else {
        return false;
    }
}

function getLineThree(headline) {
    if ( getOffsetHeight('maxHeightThreeLines', headline) ) {
        return true;
    } else {
        return false;
    }
}


function getTextByLineHeight( headline, maxHeight ) {
    var textArray = headline.innerHTML.split(' '), 
        textContent = '', text_line_1 = '', text_line_2 = '', text_line_3 = '', text_line_rest = '';

    for (var i=0; i<textArray.length; i++) {
        if ( i == 0 ) {
            headline.innerHTML = textArray[i]
        } else {
            textContent = headline.innerHTML;
            headline.innerHTML += ' '+textArray[i]
        }

        // headline.style.maxHeight = '153px';

        if ( getLineOne(headline) ) {
            text_line_1 = headline.innerHTML;
            // console.log( 'line 1: ', text_line_1 );
        } else if ( getLineTwo(headline) ) {
            text_line_2 = headline.innerHTML.replace(text_line_1+' ', '');
            // console.log( 'line 2: ', text_line_2 );
        } else if ( getLineThree(headline) ) {
            text_line_3 = headline.innerHTML.replace(text_line_1+' '+text_line_2+' ', '');
            console.log( 'html', headline.innerHTML );
            console.log( 'line 3: ', text_line_3 );
        } else {
            text_line_rest = headline.innerHTML.replace(text_line_1+' '+text_line_2+' '+text_line_3+' ', '');
        }


if ( i == 6 ) {
    break;
}


        // console.log( 'height: ', headline.offsetHeight, ' :: ', getOffsetHeight(headline, 'maxHeightThreeLines'), headline.innerHTML );
        
        // zeile 1 ==  57px
        // zeile 2 == 105px
        // zeile 3 == 153px





        // if ( getOffsetHeight(headline, 'maxHeightThreeLines') && !closed ) {
            // next line
// console.log( 'close tag' );

//             headline.innerHTML = textContent + '</span>' + ' ' + textArray[i];
//             closed = true;
        // }

        // console.log( 'headline: ', headline.innerHTML );
        // if ( getOffsetHeight(headline, 'maxHeightTwoLines') && !opened ) {
            // next line

// console.log( 'open tag' );

// console.log( 'html: ', headline.innerHTML );
// console.log( 'text: ', textContent, textArray[i] );

//             lineThree = '<span>' + ' ' + textArray[i];

//             headline.innerHTML = textContent + '<span>' + ' ' + textArray[i];
//             opened = true;
            // console.log( 'offsetHeight: ', getOffsetHeight(headline, 'maxHeightTwoLines') );
            // console.log( 'height: ', headline.offsetHeight );
// console.log( 'html: ', headline.innerHTML );
        // }

    }

    if ( maxHeight == 'maxHeightThreeLines' ) {

        // headline.classList.add('maxHeightThreeLines');
        // headline.innerHTML = text_line_1 + ' ' + text_line_2 + ' <span>'+ text_line_3 +'</span>'+ text_line_rest;
    }



}


function shorten_headline(wrapper, headline) {
    var zeil
    if ( headline != null ) {

        if ( wrapper.classList.contains('magazinteaser') ) {

            // console.log( 'Magazinteaser' );
            if ( !getOffsetHeight('maxHeightThreeLines', headline) ) {
                getTextByLineHeight( headline, 'maxHeightThreeLines' );
            }
        }







        // console.log( 'wrapper: ', wrapper );
        




// ....
// console.log( headline.tagName + ': ', headline );
headline.style.border = '3px solid red';
    }
}


function init__teaser_vars() {
    var shortenContent = document.querySelectorAll('.teaserContentToShorten');
    
    if ( shortenContent.length >= 1 ) {
        for (a=0; a<shortenContent.length; a++) {

            shorten_headline(shortenContent[a], shortenContent[a].querySelector('h1'));
            // shorten_headline(shortenContent[a], shortenContent[a].querySelector('h2'));
            // shorten_headline(shortenContent[a], shortenContent[a].querySelector('h3'));
            // shorten_headline(shortenContent[a], shortenContent[a].querySelector('h4'));



// ....
shortenContent[a].style.border = '3px solid blue';
// console.log( shortenContent[a] );
        }
    }



//     const   shortenContent = document.querySelectorAll('.teaserContentToShorten');
//     let     a, b, shorten, headline, textContent, realHeadlineText, headlineWithSpan = '', headlineWithoutSpan = '', touchedLineTwo = false;

//     // console.log( shortenContent );

//     if ( shortenContent.length >= 1 ) {

//         // Zu lange Headlines und Texte werden gekürzt.
//         for (a=0; a<shortenContent.length; a++) {
//             // if (a == 0) continue;
//             shorten = false;

// // console.log( shortenContent[a].clientHeight, shortenContent[a].offsetHeight );

//             if ( shortenContent[a].classList.contains('magazinteaser') ) {
//                 // console.log( 'Magazinteaser: ', shortenContent[a].classList.contains('magazinteaser') );
//                 headline = shortenContent[a].querySelector('h1');
//                 textContent = shortenContent[a].querySelector('p.copy');

//                 // console.log( headline, textContent );
//                 // console.log( headline.clientHeight, headline.offsetHeight );
//                 // console.log( textContent.clientHeight, textContent.offsetHeight );
                
//                 var textArray = headline.innerHTML.split(' ');
// // console.log( 'textArray: ', textArray );


//                 for (b=0; b<textArray.length; b++) {
//                     if ( b == 0 ) {
//                         realHeadlineText = textArray[b];
//                         headline.innerHTML = textArray[b];
//                         // console.log( 'if ',  realHeadlineText);
//                     } else {

//                         headline.innerHTML += ' ' + textArray[b];
// // console.log( 'clientHeight: ', headline.clientHeight );

//                         if ( headline.clientHeight > 50 && headline.clientHeight < 100 ) {

//                             if ( b  == textArray.length-1) {
//                                 // console.log( 'länge erreicht' );

//                                 if (!touchedLineTwo) {
//                                     realHeadlineText += ' ' + textArray[b];
//                                     headline.innerHTML = realHeadlineText;
//                                 } else {
//                                     // console.log( 'länge erreicht else' );
//                                     realHeadlineText = headlineWithOutSpan;
//                                     headline.innerHTML = realHeadlineText;
//                                 }

//                             } else {
//                                 // console.log( 'länge nicht erreicht' );
//                                 // realHeadlineText += ' <span>' + textArray[b];
                                
//                                 if (!touchedLineTwo) {
//                                     headlineWithSpan = realHeadlineText + ' <span>' + textArray[b];
//                                     headlineWithoutSpan = realHeadlineText + ' ' + textArray[b];
//                                     touchedLineTwo = true;
//                                 } else {
//                                     headlineWithSpan += ' ' + textArray[b];
//                                     headlineWithoutSpan += ' ' + textArray[b];
//                                 }

//                                 headline.innerHTML = headlineWithoutSpan;
//                             }


//                             // console.log( 'lineTwo ',  headline.innerHTML);
//                         } else if ( headline.clientHeight > 100 ) {
//                             headline.innerHTML = headlineWithSpan + ' ' + textArray[b] + '</span>';
//                             // console.log( 'break ',  realHeadlineText);
//                             break;
//                         } else {
//                             realHeadlineText += ' ' + textArray[b];
//                             // console.log( 'else ',  realHeadlineText);
//                         }
//                     }
//                 }



//                 // var test = getTextByLineHeight( headline.innerHTML );
//                 // console.log( test );
                
















//             } else if ( shortenContent[a].tagName == 'P' ) {

//                 if ( shortenContent[a].previousElementSibling.clientHeight < 30 ) {
//                     // Headline ist einzeilig
//                     // if ( shortenContent[a].clientHeight > 100 ) {
//                     //     shorten = true;
//                     //     zeilenhoehe = 'maxHeightFourLine'
//                     // }

//                 } else if ( shortenContent[a].previousElementSibling.clientHeight < 60 ) {
//                     // Headline ist zweizeilig
//                     // if ( shortenContent[a].clientHeight > 80 ) {
//                     //     shorten = true;
//                     //     zeilenhoehe = 'maxHeightThreeLine'
//                     // }

//                 }


                
//             }

//             if ( shorten ) {
//                 // shortenContent[a].classList.add(zeilenhoehe);
//                 // shortenContent[a].innerHTML = shortenContent[a].innerHTML + '<span></span>';
//             }
//         }
//     }
}


if (document.addEventListener) {
    // document.addEventListener("DOMContentLoaded", init__teaser_vars, false);
} else {
    window.onload = function () {
        init__teaser_vars();
    }
}
